const app_base_url = "/iss";
const aplicacao = "ISSQN";
const aplicacao_full_url = "https://solucoes.sinsoft.com.br/iss";
const sinsoft_url = "http://sinsoft.com.br";
//TESTES
//const api_url = "http://localhost:600";
//PRODUÇÃO
const api_url = "https://solucoes.sinsoft.com.br/api/issqn";

//
// 

//const login_api = "https://localhost:3333";
const login_api = "https://solucoes.sinsoft.com.br/api/login-unico";
//
const unico_api = "https://solucoes.sinsoft.com.br/api/consultas-unico";
const enderecos_api = "https://solucoes.sinsoft.com.br/api/enderecos";

const itbi_sql_server_url = "https://solucoes.sinsoft.com.br/api/itbi-sql-server";


const api_pix = "https://solucoes.sinsoft.com.br/api/pix/auxPix";


export { app_base_url, sinsoft_url, login_api, aplicacao, api_url, unico_api, enderecos_api, api_pix,aplicacao_full_url, itbi_sql_server_url }